import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  DatePicker,
  Form,
  Input,
  Radio,
  Row,
  Select,
  Checkbox,
  Button,
} from "antd";
import { FaDollarSign } from "react-icons/fa";
import { v4 as uuidv4 } from "uuid";
import PageHeading from "../../../../../components/common/PageHeading";
import Notes from "../../../../../components/common/Notes";
import AttachmentsUpload from "../../../../../components/common/AttachmentsUpload";

const plainOptions = [
  { label: "January", value: "January", colSpan: 6 },
  { label: "February", value: "February", colSpan: 6 },
  { label: "March", value: "March", colSpan: 6 },
  { label: "April", value: "April", colSpan: 6 },
  { label: "May", value: "May", colSpan: 6 },
  { label: "June", value: "June", colSpan: 6 },
  { label: "July", value: "July", colSpan: 6 },
  { label: "August", value: "August", colSpan: 6 },
  { label: "September", value: "September", colSpan: 6 },
  { label: "October", value: "October", colSpan: 6 },
  { label: "November", value: "November", colSpan: 6 },
  { label: "December", value: "December", colSpan: 6 },
];

const NewRecurringBill = () => {
  const [billOrCredit, setBillOrCredit] = useState("bill");

  const [checkedOptions, setCheckedOptions] = useState([]);
  const [amount, setAmount] = useState(0);
  const [inputValues, setInputValues] = useState([]);

  useEffect(() => {
    const newTotal = Object.values(inputValues).reduce(
      (total, value) => total + Number(value),
      0
    );
    setAmount(newTotal);
  }, [inputValues]);

  const handleBillOrCredit = (e) => {
    console.log("radio checked", e.target.value);
    setBillOrCredit(e.target.value);
  };

  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const onSearch = (value) => {
    console.log("search:", value);
  };

  const handleCheckboxChange = (checkedValues) => {
    setCheckedOptions(checkedValues);
  };

  const handleCheckAllChange = () => {
    const allValues = plainOptions.map((option) => option.value);
    setCheckedOptions(allValues);
  };
  const handleUnCheckAllChange = () => {
    setCheckedOptions([]);
  };

  const initialList = [{ id: uuidv4() }];

  const [accounts, setAccounts] = useState(initialList);

  function handleAddAccount() {
    const newList = accounts.concat({ id: uuidv4() });
    setAccounts(newList);
  }

  function handleRemoveAccount(id) {
    const newList = accounts.filter((item) => item.id !== id);
    setAccounts(newList);
    const newTotal = Object.values(inputValues).reduce(
      (total, value) => total + Number(value),
      0
    );
    setAmount(newTotal);
  }

  const handleAvailableAmount = (e) => {
    const newValue = Number(e.target.value);
    if (!isNaN(newValue)) {
      setInputValues({ ...inputValues, [e.target.id]: e.target.value });
    }
  };

  return (
    <div>
      <PageHeading heading="New Recurring Bill/Credit" />
      <Row gutter={16}>
        <Col>
          <Radio.Group onChange={handleBillOrCredit} value={billOrCredit}>
            <Radio value="bill">Bill</Radio>
            <Radio value="credit">Credit</Radio>
          </Radio.Group>
        </Col>
      </Row>
      <br />
      <Card title="Recurring Bill Details">
        <Form
          name="basic"
          autoComplete="off"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          initialValues={{
            remember: true,
          }}
        >
          <Row gutter={16} justify="space-between">
            <Col span={8}>
              <Form.Item label="Payee" name="Payee" required>
                <Select
                  showSearch
                  allowClear
                  placeholder=""
                  optionFilterProp="children"
                  onChange={onChange}
                  onSearch={onSearch}
                  filterOption={(input, option) =>
                    (option?.label ?? "")
                      .toLowerCase()
                      .includes(input.toLowerCase())
                  }
                  options={[
                    {
                      value:
                        "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                      label:
                        "Everything is A-OK LLC - 229 Victory Drive Norman, OK 73072",
                    },
                    {
                      value: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                      label: "AT&T - PO Box 5014  Carol Stream, IL 60197",
                    },
                    {
                      value:
                        "Terry's Appliance Center - 325 South Sooner Road  Midwest City, OK 73110",
                      label:
                        "Terry's Appliance Center - 325 South Sooner Road  Midwest City, OK 73110",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Total Amount" name="totalAmount" required>
                <Input defaultValue="0.00" />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} justify="space-between">
            <Col span={8}>
              <Form.Item label=" Start Date" name=" Start Date" required>
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label=" End Date" name=" End Date">
                <DatePicker format="MM-DD-YYYY" style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} justify="space-between">
            <Col span={8}>
              <Form.Item label="Bill Day" name="BillDay" required>
                <Input defaultValue="1" />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Due Day" name="DueDay" required>
                <Input />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} justify="space-between">
            <Col span={8}>
              <Form.Item label="Remarks" name="Remarks">
                <Input />
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item label="Post Code" name="PostCode">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          {billOrCredit === "credit" ? null : (
            <Row gutter={16} justify="space-between">
              <Col span={8}>
                <Form.Item label="Memo on Check" name="MemoOnCheck">
                  <Input />
                </Form.Item>
              </Col>
            </Row>
          )}

          <Row gutter={16} justify="space-between">
            <Col span={8}>
              <Form.Item label="Repeats" name="Repeats">
                <Select
                  labelInValue
                  defaultValue={{
                    value: "Monthly",
                    label: "Monthly",
                  }}
                  options={[
                    {
                      value: "Monthly",
                      label: "Monthly",
                    },
                    {
                      value: "DOES_NOT_REPEAT",
                      label: "Never (Must Post Manually)",
                    },
                  ]}
                />
              </Form.Item>
            </Col>
          </Row>
          <br />
          <Row gutter={16} justify="space-between">
            <Col span={8}>
              <Form.Item label="Select Months: " required>
                <Button type="link" onClick={handleCheckAllChange}>
                  All
                </Button>
                <Button type="link" onClick={handleUnCheckAllChange}>
                  None
                </Button>
              </Form.Item>
            </Col>
          </Row>

          <Row>
            {plainOptions.map((option) => (
              <Col span={option.colSpan} key={option.value}>
                <Checkbox
                  value={option.value}
                  checked={checkedOptions.includes(option.value)}
                  onChange={(e) =>
                    handleCheckboxChange(
                      e.target.checked
                        ? [...checkedOptions, option.value]
                        : checkedOptions.filter(
                            (value) => value !== option.value
                          )
                    )
                  }
                >
                  {option.label}
                </Checkbox>
              </Col>
            ))}
          </Row>
        </Form>
      </Card>
      <br />
      <Card>
        <ul>
          <Row style={{ marginBottom: 12 }}>
            <Col className="tableHead" span={5}>
              <p>* Properties</p>
            </Col>
            <Col className="tableHead" span={5}>
              <p>Unit</p>
            </Col>
            <Col className="tableHead" span={5}>
              <p>* Account</p>
            </Col>
            <Col className="tableHead" span={5}>
              <p>Description</p>
            </Col>
            <Col className="tableHead" span={3}>
              <p>* Amount</p>
            </Col>
            <Col span={1}></Col>
          </Row>
          {accounts.map((item) => (
            <li key={item.id}>
              <Form.Item label="">
                <Row gutter={16}>
                  <Col span={5}>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      filterOption={(input, option) =>
                        (option?.label ?? "")
                          .toLowerCase()
                          .includes(input.toLowerCase())
                      }
                      options={[
                        {
                          value: "test1 - 912 n creek dr  edmond, OK 73034",
                          label: "test1 - 912 n creek dr  edmond, OK 73034",
                        },
                        {
                          value:
                            "GF3, Block 58, Seaview Apartments, DHA Phase 5 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi, 75500",
                          label:
                            "GF3, Block 58, Seaview Apartments, DHA Phase 5 P/O Sost Nazimabad, Gojal Hunza, Hunza Nagar Karachi, 75500",
                        },
                        {
                          value:
                            "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                          label:
                            "9723 NE 3rd Pl - 9723 NE 3rd Pl Midwest City, OK 73130",
                        },
                      ]}
                    />
                  </Col>
                  <Col span={5}>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      options={[
                        {
                          value: "test",
                          label: "test",
                        },
                      ]}
                    />
                  </Col>
                  <Col span={5}>
                    <Select
                      showSearch
                      allowClear
                      style={{ width: "100%" }}
                      options={[
                        {
                          label: "Asset",
                          options: [
                            {
                              label: "101: Accounts Receivable",
                              value: "101: Accounts Receivable",
                            },
                            {
                              label: "102: Undeposited Funds",
                              value: "102: Undeposited Funds",
                            },
                            {
                              label: "377535: Bank of America - 9538",
                              value: "377535: Bank of America - 9538",
                            },
                            {
                              label: "382414: Far Wespen",
                              value: "382414: Far Wespen",
                            },
                          ],
                        },
                      ]}
                    />
                  </Col>
                  <Col span={5}>
                    <Input />
                  </Col>
                  <Col span={3}>
                    <Input
                      placeholder="Amount"
                      addonBefore={<FaDollarSign size={12} />}
                      defaultValue={(Math.round(0 * 100) / 100).toFixed(2)}
                      onChange={handleAvailableAmount}
                      id={item.id}
                      value={inputValues.value}
                    />
                  </Col>
                  <Col span={1}>
                    {accounts.length > 1 ? (
                      <Button
                        className="roundSmallButton"
                        onClick={() => {
                          handleRemoveAccount(item.id);
                        }}
                        type="primary"
                        shape="circle"
                        icon={<i className="fa-sharp fa-solid fa-xmark"></i>}
                        size={"small"}
                      />
                    ) : (
                      <></>
                    )}
                  </Col>
                </Row>
              </Form.Item>
            </li>
          ))}

          <Form.Item label="">
            <Button
              className="addPropertyGroupButton"
              type="primary"
              onClick={handleAddAccount}
              size={"small"}
              icon={<i className="fa-solid fa-circle-plus"></i>}
            >
              {" "}
              Add Another Line
            </Button>
          </Form.Item>

          <Row justify="end">
            <Col span={4}>
              <h4>Total: </h4>
            </Col>
            <Col span={2}>
              <h4>$ {(Math.round(amount * 100) / 100).toFixed(2)} </h4>
            </Col>
          </Row>
        </ul>
      </Card>
      <br />
      <Row gutter={16}>
        <Col>
          <Button type="primary">Save & Add Another</Button>
        </Col>
        <Col>
          <Button>Save</Button>
        </Col>
        <Col>
          <Button type="link">Cancel</Button>
        </Col>
      </Row>
      <br />
      <Row gutter={[0, 24]}>
        <Col span={24}>
          {/* <Notes /> */}
        </Col>
        <Col span={24}>
          {/* <AttachmentsUpload /> */}
        </Col>
      </Row>
      <div className="RightSidebar"></div>
    </div>
  );
};

export default NewRecurringBill;
